/**
 * HL: mobile filter dropdown — bottom sheet with scrollable panel (not Fancybox).
 */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 798px)');

  function dropdowns() {
    return document.querySelectorAll('[data-hl-filter-dropdown]');
  }

  function eventTargetElement(e) {
    var target = e.target;
    if (!target) return null;
    if (target.nodeType === Node.ELEMENT_NODE) return target;
    return target.parentElement;
  }

  function syncGroups(root) {
    if (!root) return;
    root.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var heading = group.querySelector('.sidebar__block-heading.toggle');
      var panel = group.querySelector('[data-filter-group-list], ul.toggle_list');
      var toggle = heading && heading.querySelector('span');
      if (!heading || !panel || !toggle) return;

      var hasActive =
        group.querySelector('[data-filter-active]') ||
        group.querySelector(
          '.faceted-filters__filter-link--active:not(.hl-filter-all-brands .faceted-filters__filter-link--active)'
        );

      var open = !!hasActive;
      panel.style.display = open ? 'block' : 'none';
      toggle.textContent = open ? '\u2212' : '+';
      heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function ensureBackdrop() {
    var backdrop = document.getElementById('hl-filter-dropdown-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'hl-filter-dropdown-backdrop';
      backdrop.className = 'hl-filter-dropdown-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', function () {
        closeAll();
      });
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function syncBackdrop() {
    var open = document.querySelector('.hl-filter-dropdown--open');
    var backdrop = ensureBackdrop();
    if (open && MOBILE_MQ.matches) {
      backdrop.classList.add('hl-filter-dropdown-backdrop--visible');
      document.documentElement.classList.add('hl-filter-dropdown-open');
    } else {
      backdrop.classList.remove('hl-filter-dropdown-backdrop--visible');
      document.documentElement.classList.remove('hl-filter-dropdown-open');
    }
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;
    var toggle = dropdown.querySelector('[data-hl-filter-dropdown-toggle]');
    var panel = dropdown.querySelector('[data-hl-filter-dropdown-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', '');
    dropdown.classList.remove('hl-filter-dropdown--open');
    syncBackdrop();
  }

  function closeAll(except) {
    dropdowns().forEach(function (dropdown) {
      if (except && dropdown === except) return;
      closeDropdown(dropdown);
    });
    syncBackdrop();
  }

  function expandAllGroups(root) {
    if (!root) return;
    root.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var heading = group.querySelector('.sidebar__block-heading.toggle');
      var panel = group.querySelector('[data-filter-group-list], ul.toggle_list');
      var toggle = heading && heading.querySelector('span');
      if (!heading || !panel || !toggle) return;
      panel.style.display = 'block';
      toggle.textContent = '\u2212';
      heading.setAttribute('aria-expanded', 'true');
    });
  }

  function openDropdown(dropdown) {
    var toggle = dropdown.querySelector('[data-hl-filter-dropdown-toggle]');
    var panel = dropdown.querySelector('[data-hl-filter-dropdown-panel]');
    if (!toggle || !panel) return;

    closeAll(dropdown);
    expandAllGroups(dropdown.querySelector('.hl-sidebar-filters'));
    toggle.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    dropdown.classList.add('hl-filter-dropdown--open');
    syncBackdrop();
    if (MOBILE_MQ.matches) {
      panel.scrollTop = 0;
    }
  }

  function onToggleActivate(e) {
    if (!MOBILE_MQ.matches) return;

    var target = eventTargetElement(e);
    if (!target) return;

    var toggle = target.closest('[data-hl-filter-dropdown-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var dropdown = toggle.closest('[data-hl-filter-dropdown]');
      if (!dropdown) return;
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
      return;
    }

    if (target.id === 'hl-filter-dropdown-backdrop') return;

    if (!target.closest('[data-hl-filter-dropdown]')) {
      closeAll();
    }
  }

  document.addEventListener('click', onToggleActivate, true);
  document.addEventListener('touchend', onToggleActivate, true);

  document.addEventListener('DOMContentLoaded', function () {
    dropdowns().forEach(function (dropdown) {
      syncGroups(dropdown.querySelector('.hl-sidebar-filters'));
    });
    syncBackdrop();
  });

  window.hlFilterDropdown = {
    closeAll: closeAll,
    sync: function () {
      dropdowns().forEach(function (dropdown) {
        syncGroups(dropdown.querySelector('.hl-sidebar-filters'));
      });
      syncBackdrop();
    },
  };
})();
